import React from 'react';

const TermosAceite = props => {
    return (
        <div className="politica aceite cadastro">
            <div className="">
                <h3><b>Termos e Condições de Uso</b></h3>
                <br />

                <p style={{ textAlign: 'justify' }}>
                    O acesso e o uso do website da <b>www.lekacatalogos.com.br</b> (doravante
                        referenciado como "site da Leka Catálogos") e as informações, materiais, produtos e
                        serviços disponíveis por meio do site da Leka Catálogos estão sujeitos a estes termos
                        de uso (os "termos e condições de uso do site").
                        <br />
                        Além disso, para Revendedor(a) Leka Catálogos, aplicam-se os princípios
                        comerciais da Leka Catálogos e as políticas da Leka Catálogos e, para qualquer
                        aquisição de bens e serviços, aplicam-se os "termos e condições de compra da Leka
                        Catálogos".
                        <br />
                        Os termos de uso do site podem ser atualizados periodicamente. Versões
                        atualizadas serão publicadas no site da Leka Catálogos, entrando em vigor
                        imediatamente. Ao usar o site da Leka Catálogos, você deve verificar regularmente se
                        os termos de uso do site foram atualizados ou alterados.
                        <br />
                        O site da Leka Catálogos fornece informações sobre a Leka Catálogos, a
                        oportunidade de negócios Leka Catálogos e produtos e serviços da Leka Catálogos,
                        destinando-se exclusivamente ao uso no Brasil, sendo regido pela legislação
                        brasileira. A Leka Catálogos não assume qualquer responsabilidade pelo uso do site
                        da Leka Catálogos a partir de outros países.
                        <br /><br />
                    <b>1. Partes do site da Leka Catálogos protegidas por senha.</b>
                    <br />
                        As partes protegidas por senha do site da Leka Catálogos destinam-se exclusivamente a
                        Revendedor(a) Leka Catálogos e seus clientes do Brasil.
                        <br />
                        Nota: As senhas não devem ser fornecidas a terceiros, devendo ser protegidas contra acesso não autorizado.
                        Caso tome conhecimento de qualquer uso não autorizado da sua senha, você deve informar a Leka Catálogos
                        imediatamente. A Leka Catálogos não assume qualquer responsabilidade por danos causados como
                        consequência do uso inadequado de senhas.
                        <br /><br />
                    <b>2. Declaração de privacidade e políticas da Leka Catálogos.</b>
                    <br />
                        Todos os dados pessoais fornecidos à Leka Catálogos durante o uso do site da Leka
                        Catálogos serão manipulados de acordo com a política de privacidade do site. Todas as
                        informações fornecidas à Leka Catálogos durante o uso do site da Leka Catálogos devem ser
                        corretas, completas e atualizadas. Se tivermos razões para crer que tenham sido fornecidas
                        informações incorretas, incompletas ou desatualizadas, o acesso ao site da Leka Catálogos
                        pode ser limitado ou bloqueado.
                        <br /><br />
                    <b>3. Direitos autorais e uso de materiais do site da Leka Catálogos.</b>
                    <br />
                        O site da Leka Catálogos e os materiais disponibilizados no mesmo são protegidos por direitos
                        de propriedade intelectual, inclusive direitos autorais, copyrights, nomes comerciais e marcas
                        comerciais, dentre os quais o nome "Leka Catálogos" e o logotipo da Leka Catálogos, são
                        propriedade da Leka Catálogos ou usados pela Leka Catálogos mediante licença ou permissão
                        do proprietário dos direitos correspondentes. Materiais protegidos por esses direitos de
                        propriedade intelectual incluem o design, layout, aspecto visual, aparência, elementos gráficos,
                        fotografias, imagens, artigos, histórias e outros materiais disponíveis no site da Leka Catálogos
                        (coletivamente, "materiais do site").
                        <br />
                        Os materiais do site só podem ser reproduzidos, distribuídos, publicados ou apresentados
                        publicamente de qualquer outra forma mediante autorização prévia por escrito da Leka
                        Catálogos. Como exceção a essa regra, a Leka Catálogos concede aos seus Revendedores
                        uma licença limitada, não exclusiva e revogável de usar os materiais do site exclusivamente
                        com o propósito de operar seu negócio, incluindo download, armazenamento, impressão,
                        cópia, distribuição e exibição dos materiais do site, desde que os materiais sejam utilizados
                        sem qualquer alteração e a fonte das informações seja citada caso qualquer material do site
                        seja divulgado a terceiros. Caso tenha qualquer pergunta ou dúvida adicional sobre o uso dos
                        materiais do site, entre em contato conosco por meio do formulário de contato. O direito de
                        usar as partes protegidas por senha do site da Leka Catálogos como Revendedor(a) Leka
                        Catálogos termina juntamente com o encerramento do contrato de Revendedor(a) Leka
                        Catálogos, sem a necessidade de quaisquer ações adicionais por parte da Leka Catálogos. No
                        caso de encerramento do contrato, o(a) Revendedor(a) Leka Catálogos deve excluir, apagar ou
                        destruir todo e qualquer material armazenado, impresso ou copiado, a não ser aqueles que
                        precisem ser conservados em função de exigências legais.
                        <br /><br />
                    <b>4. Links para outros sites da web.</b>
                    <br />
                        Podemos fornecer links para outros sites da web, que não estejam sob nosso controle. Não
                        temos responsabilidade pelas informações e materiais disponibilizados por esses outros sites.
                        Recomendamos que você leia os termos de uso e as declarações de privacidade de qualquer
                        site da web antes de usá- lo ou submeter qualquer dado pessoal ou qualquer outra informação
                        no site ou por meio dele.
                        <br /><br />
                    <b>5. Links de outros sites da web para o site da Leka Catálogos.</b>
                    <br />
                        Fornecer links para www.lekacatalogos.com.br a partir de qualquer outro site da web exige
                        autorização prévia por escrito da Leka Catálogos.
                        <br /><br />
                    <b>6. Limitação de responsabilidade, isenção de garantias e indenização.</b>
                    <br />
                        Na extensão permitida pela legislação aplicável, nem a Leka Catálogos nem suas filiadas terão
                        qualquer responsabilidade por qualquer dano direto, indireto, consequente ou de qualquer
                        outro tipo, inclusive, dentre outras, danos à propriedade, perda do uso, perda de negócios,
                        perdas econômicas, perda de dados ou lucros cessantes, decorrentes ou relacionados ao uso
                        ou acesso ou à impossibilidade de usar ou acessar o site da Leka Catálogos ou seu conteúdo.
                        <br />
                        A Leka Catálogos fará esforços razoáveis para assegurar que as informações e os materiais
                        fornecidos neste site da web estejam corretos. No entanto, a Leka Catálogos não pode garantir
                        a correção de todas as informações e materiais disponíveis no mesmo, não assumindo
                        qualquer responsabilidade, inclusive civil, pela exatidão, integralidade ou autenticidade de
                        qualquer informação ou material contido neste site. Não garantimos que a operação deste site
                        da web seja ininterrupta ou livre de erros, ou que este site esteja livre de vírus ou outros
                        componentes que possam ser prejudiciais a equipamentos ou software. A Leka Catálogos não
                        garante que o site da Leka Catálogos seja compatível com os equipamentos e software que
                        você possa vir a usar, nem garante que o site da Leka Catálogos esteja disponível o tempo
                        todo ou em qualquer horário específico.
                        <br />
                        Você concorda em indenizar, defender e isentar de responsabilidade a Leka Catálogos e suas
                        filiadas em relação a qualquer responsabilidade civil ou perda relacionada à violação destes
                        termos de uso do site ou seu uso do site da Leka Catálogos.
                        <br /><br />
                    <b>7. Restrição ou bloqueio do acesso ao site da Leka Catálogos em função de violação dos
                        termos de uso do site.</b>
                    <br />
                        Em caso de qualquer violação dos termos de uso do site, particularmente no caso do uso do
                        site da Leka Catálogos ou elementos individuais do site da Leka Catálogos de qualquer forma
                        distinta de seu uso previsto, o acesso ao site da Leka Catálogos pode ser restrito ou
                        bloqueado.
                        <br />
                        A Leka Catálogos se reserva, de forma geral, o direito de, parcial ou completamente, alterar,
                        bloquear ou suspender o site da Leka Catálogos ou seu conteúdo, a qualquer momento e por
                        qualquer razão.
                        <br /><br />
                    <b>8. Anulação de cláusulas</b>
                    <br />
                        Caso alguma das cláusulas destes termos de uso do site seja inválida ou declarada inválida
                        por um tribunal, tal invalidação não afetará a validade das demais cláusulas.
                        <br /><br />
                    <b>9. Escolha de legislação, jurisdição e foro.</b>
                    <br />
                        O uso do site da Leka Catálogos e estes termos de uso do site são regidos pelas leis do Brasil.
                        Exceto onde determinado de outra forma por lei, o foro da cidade de Guarulhos, estado de São
                        Paulo tem jurisdição para qualquer disputa decorrente ou relacionada ao uso do site da Leka
                        Catálogos ou a estes termos de uso do site.
                        </p>

            </div>
        </div>
    );
};

export default TermosAceite;